import { api } from "../api";

/* ======================================
   LISTAR FAVORITOS
====================================== */

export async function listarFavoritos() {
  try {
    // v2: cada favorito traz a faixa de preço e se tem variações.
    const response = await api.get("/v2/favorites");
    return response.data || [];
  } catch (error: any) {
    console.error("STATUS:", error.response?.status);
    console.error("BODY:", error.response?.data);
    throw error;
  }
}

/* ======================================
   TOGGLE FAVORITO
====================================== */

export async function toggleFavorito(productId: string) {
  try {

    const response = await api.post("/favorites", {
      productId,
    });


    return response.data;
  } catch (error) {
    console.error("Erro ao alterar favorito:", error);
    throw error;
  }
}

/* ======================================
   ADICIONAR FAVORITO
====================================== */

export async function adicionarFavorito(productId: string) {
  return await toggleFavorito(productId);
}

/* ======================================
   REMOVER FAVORITO
====================================== */

export async function removerFavorito(productId: string) {
  return await toggleFavorito(productId);
}